/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type TextSendMessageRequestType =
  (typeof TextSendMessageRequestType)[keyof typeof TextSendMessageRequestType];

export const TextSendMessageRequestType = {
  user_input: "user_input",
  rx_input: "rx_input",
  talk_to_doctor: "talk_to_doctor",
  talk_to_doctor_ai_upsell_accept: "talk_to_doctor_ai_upsell_accept",
  location_input: "location_input",
} as const;
